module.exports = __webpack_public_path__ + "images/root/mainVisual_appeal_sp_6e085857f06024b6ea3afb90f02dc620.svg";